import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Lock, CreditCard, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { DEPOSIT_STATUS, fmtEur, fmtDateTime } from "@/components/admin/ui-lite";
import { fmtParisLong } from "@/components/location/DateTimeFields";

export default function LocationDeposit() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const sid = sp.get("session_id");
    (sid ? api.get(`/location/deposit/${token}/confirm`, { params: { session_id: sid } }) : api.get(`/location/deposit/${token}`))
      .then((r) => setD(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, [token, sp]);
  const go = async () => {
    setBusy(true);
    try { const r = await api.post(`/location/deposit/${token}/checkout`, { origin_url: window.location.origin }); window.location.href = r.data.url; }
    catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };
  if (!d) return <div className="pt-40 pb-24 text-center text-white/45 italic">Chargement…</div>;
  const saved = d.deposit_status !== "a_obtenir";
  return (
    <section className="pt-32 md:pt-40 pb-24 px-6 max-w-2xl mx-auto" data-testid="deposit-page">
      <p className="eyebrow">Dépôt de garantie · {d.number}</p>
      <h1 className="font-serif-luxe text-4xl md:text-5xl mt-3">Votre caution par <span className="italic gold-text">carte bancaire.</span></h1>
      <div className="card-luxe p-6 mt-8 space-y-2 text-sm">
        <p className="text-white/70">{d.items.map((i) => `${i.quantity}× ${i.name}`).join(" · ")}</p>
        <p className="text-white/70 first-letter:uppercase" data-testid="deposit-dates">Du {fmtParisLong(d.start_at)} au {fmtParisLong(d.end_at)}</p>
        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-[#DCB457]/15 mt-4">
          <div><p className="text-[10px] uppercase tracking-[0.2em] text-white/45">Location</p><p className="font-serif-luxe text-2xl">{fmtEur(d.rental_total)}</p></div>
          <div><p className="text-[10px] uppercase tracking-[0.2em] text-white/45">Dépôt de garantie</p><p className="font-serif-luxe text-2xl gold-text" data-testid="deposit-amount">{d.deposit_amount ? fmtEur(d.deposit_amount) : "à confirmer"}</p></div>
        </div>
      </div>
      <p className="text-sm text-white/65 leading-relaxed mt-6" data-testid="deposit-explanation">{d.explanation}</p>
      {saved ? (
        <div className="card-luxe p-6 mt-6 border-emerald-500/30" data-testid="deposit-saved">
          <CheckCircle2 className="text-emerald-300" size={26} strokeWidth={1.3} />
          <p className="font-serif-luxe text-xl mt-3">Garantie enregistrée</p>
          {d.card && <p className="text-sm text-white/60 mt-1">Carte {d.card.brand?.toUpperCase()} •••• {d.card.last4}</p>}
          <p className="text-xs text-white/45 mt-2">Statut : {DEPOSIT_STATUS[d.deposit_status]}</p>
        </div>
      ) : (
        <button onClick={go} disabled={busy || !d.deposit_amount} className="btn-gold mt-8 w-full inline-flex justify-center gap-2" data-testid="deposit-register-btn">
          <CreditCard size={15} /> {busy ? "Redirection…" : "Enregistrer ma carte de garantie"}
        </button>
      )}
      <p className="text-[11px] text-white/40 mt-5 inline-flex items-center gap-1.5"><Lock size={11} /> Paiement sécurisé par Stripe — carte bancaire uniquement. Aucune donnée bancaire n'est conservée par My Animation.</p>
    </section>
  );
}
